// BCM-898 · PA1 — Post-manufacturing documents not received (slide 6). [Uday]
// Status 3 (Production Complete). Informational only — no user action; the CMO has
// already been notified. Lists every configured Post-Manufacturing document with a
// Received / Not Received chip. Gate on status + document difference, never on
// `fulfilled` (defect D11).
import React from "react";
import DocumentsPendingCard from "../components/common/DocumentsPendingCard";
import { DOC_CATEGORY } from "../utils/constants";

const PA1PostMfgDocuments = ({ row, viewOnly }) => (
  <DocumentsPendingCard
    row={row}
    category={DOC_CATEGORY.POST_MANUFACTURING}
    title="Post-Manufacturing documents are not yet received"
    successTitle="All post-manufacturing documents have been received"
    subText="The batch will not move ahead unless the pending documents listed below are received."
    viewOnly={viewOnly}
  />
);

export default PA1PostMfgDocuments;
